import * as ActionTypes from '../actions/ActionTypes';
import KnowledgeScopesRecord from '../records/KnowledgeScopesRecord';
export default function knowledgeScopes(state = new KnowledgeScopesRecord(), action) {
  switch (action.type) {
    case ActionTypes.APP_STARTED:
      return KnowledgeScopesRecord.from(action.user.scopes);
    default:
      return state;
  }
}